import { TJsonQueryOptionalKeysToReset } from '../../JsonQuery';

export const TERMS_TO_RESET: TJsonQueryOptionalKeysToReset[] = [
  'geo',
  'room_area',
  'kitchen',
  'living_area',
  'balconies',
  'loggia',
  'bedroom_total',
  'ceiling_height',
  'cl',
  'has_decoration',
  'apartment',
  'only_flat',
  'penthouse',
  'lifts',
  'lift_service',
  'flat_share',
  'floorn',
  'floor',
  'is_first_floor',
  'not_last_floor',
  'rooms_count',
  'is_in_hidden_base',
  'wp',
  'wc',
  'wc_type',
  'wc_site',
  'windows_type',
  'description_exclude',
  'description_include',
  'repair',
  'rooms_for_sale',
  'garage',
  'garage_material',
  'garage_status',
  'garage_type',
  'garage_garage_type',
  'heating_source_type',
  'house_material',
  'house_year',
  'land_status',
  'room_type',
  'id',
  'id_user',
  'parking_type',
  'contact',
  'publish_period',
  'prepay',
  'zalog',
  'is_dacha',
  'composition',
  'with_layout',
  'only_foot',
  'tour_3d',
  'suburban_offer_filter',
  'kp_id',
  'has_profitbase_booking',
  'bbox',
  'from_developer',
  'yeargte',
  'year',
  'domrf',
  'demolished_in_moscow_programm',
  'electricity',
  'has_electricity',
  'has_extinguishing_system',
  'has_furniture',
  'has_heating',
  'has_light',
  'has_water',
  'has_video',
  'has_drainage',
  'is_by_homeowner',
  'deal_rent',
  'include_new_moscow',
  'hand_over',
  'bath',
  'conditioner',
  'dish_washer',
  'has_fridge',
  'has_fridge',
  'internet',
  'kids',
  'has_kitchen_furniture',
  'pets',
  'phone',
  'pool',
  'bathhouse',
  'security',
  'shower',
  'tv',
  'has_washer',
  'ipoteka',
  'gas',
  'sost_type',
  'offer_seller_type',
  'foot_min',
  'promo_search_types',
  'kitchen_stove',
  'commission',
  'has_ramp',
  'wheelchair_accessible',
  'decorations_list',
  'estate_type',
  'placement_type',
  'building_house_line_type__shopping_area',
  'building_heating_type',
  'building_lift_types_type',
  'building_cranage_types_type',
  'building_gates_type',
  'building_class_type',
  'building_class_type__warehouse',
  'input_type',
  'condition_type',
  'condition_type__free_appointment_object',
  'condition_type__industry',
  'building_type__building',
  'building_type2',
  'all_day_access',
  'all_week_access',
  'commission_type',
  'enter',
  'amenity',
  'contract',
  'is_by_commercial_owner',
  'cl',
  'specialty_types',
  'electronic_trading',
  'coworking_id',
  'floor_types',
  'infrastructure_has_car_wash',
  'infrastructure_has_car_service',
  'infrastructure_has_pharmacy',
  'infrastructure_has_clothes_studio',
  'infrastructure_has_atm',
  'infrastructure_has_pool',
  'infrastructure_has_buffet',
  'infrastructure_has_exhibition_and_warehouse_complex',
  'infrastructure_has_hotel',
  'infrastructure_has_cafe',
  'infrastructure_has_cinema',
  'infrastructure_has_conference_room',
  'infrastructure_has_medical_center',
  'infrastructure_has_minimarket',
  'infrastructure_has_notary_office',
  'infrastructure_has_bank_department',
  'infrastructure_has_park',
  'infrastructure_has_restaurant',
  'infrastructure_has_beauty_shop',
  'infrastructure_has_warehouse',
  'infrastructure_has_canteen',
  'infrastructure_has_supermarket',
  'infrastructure_has_shopping_area',
  'infrastructure_has_fitness_centre',
  'infrastructure_has_studio',
  'infrastructure_has_central_reception',
];

export const EXTENDED_TERMS_TO_RESET: TJsonQueryOptionalKeysToReset[] = [...TERMS_TO_RESET, 'site', 'total_area'];
